import React from "react";
import { PinInput, Button, Text } from "@mantine/core";

interface VerificationFormProps {
  onComplete: () => void;
  email: string;
  isSubmitting: boolean;
  resendTimer: number;
  onVerify: (code: string, email: string) => Promise<boolean>;
  onResendCode: (email: string) => Promise<boolean>;
  startResendTimer: () => void;
}

const VerificationForm = ({
  onComplete,
  email,
  isSubmitting,
  resendTimer,
  onVerify,
  onResendCode,
  startResendTimer,
}: VerificationFormProps) => {
  const [code, setCode] = React.useState("");

  const handleContinue = async () => {
    if (code.length === 6) {
      const success = await onVerify(code, email);
      if (success) {
        onComplete();
      } else {
        setCode("");
      }
    }
  };

  const handleResend = async () => {
    const success = await onResendCode(email);
    if (success) {
      setCode("");
      startResendTimer();
    }
  };

  return (
    <div className="verification">
      <div>
        <Text size="xl" fw={700}>
          Verify your email
        </Text>
        <Text size="sm" c="dimmed">
          We sent a 6-digit code to <b>{email}</b>. Please enter the code below
          to confirm your email address.
        </Text>
      </div>

      <PinInput
        length={6}
        value={code}
        onChange={setCode}
        size="lg"
        oneTimeCode
        style={{ margin: "20px 0" }}
      />

      <Button
        fullWidth
        disabled={code.length < 6 || isSubmitting}
        mt="md"
        onClick={handleContinue}
        loading={isSubmitting}
      >
        Continue
      </Button>

      {resendTimer > 0 ? (
        <Text mt="sm" color="blue">
          Resend code in {resendTimer}s
        </Text>
      ) : (
        <Button variant="subtle" mt="sm" onClick={handleResend}>
          Resend Code
        </Button>
      )}
    </div>
  );
};

export default VerificationForm;
